import { ICategory } from "../../../shared/interface/navigation";
import { ILabel } from "../../../shared/interface/label";

export enum SearchLevel {
  CATEGORY = "category",
  SUBCATEGORY = "subcategory",
}

type SearchBy = "name" | "labelId";

type Label = ILabel | undefined;

export const findLabel = (
  categories?: ICategory[],
  slug?: string,
  searchIn?: SearchLevel,
  searchBy?: SearchBy
): ILabel | undefined => {
  let found: Label;

  if (!categories || !slug) return undefined;

  const searchField = searchBy || "name";

  if (!searchIn || searchIn === SearchLevel.CATEGORY) {
    found = categories.find((cat) => cat[searchField] === slug);
  }

  if (!searchIn || searchIn === SearchLevel.SUBCATEGORY) {
    if (!found) {
      categories.some((category) => {
        found = category.children?.find((subCat) => {
          if (subCat[searchField] === slug) {
            subCat["parentName"] = category.name;
            return true;
          }
          return false;
        });
        return !!found;
      });
    }
  }
  return found;
};

export const findSubcategoryFromLabelIds = (
  categories: ICategory[],
  labelIds?: ILabel["labelId"][]
): Label => {
  if (!categories || !labelIds) return undefined;
  let label: Label;
  labelIds.some((labelId) => {
    label = findLabel(categories, labelId, SearchLevel.SUBCATEGORY, "labelId");
    return !!label;
  });
  return label;
};
